import {
  createNavigationContainerRef,
  useNavigation,
} from "@react-navigation/native";
import { StackName } from "utils";

export const navigationRef = createNavigationContainerRef();

export function navigate(
  name: StackName,
  params?: object,
  cancelDebounce?: boolean,
) {
  return new Promise<void>((resolve) => {
    if (__DEV__) {
      console.log("SCREEN:", name);
    }
    navigationRef.current?.navigate(name as any, params);
    resolve();
  });
}

export const useNavigationLog = () => {
  const navigation = useNavigation();

  return (name: StackName, params?: object) => {
    if (__DEV__) {
      console.log("SCREEN:", name, params);
    }
    navigation.navigate(name as any, params);
  };
};

export function goBack() {
  return new Promise((rs, rj) => {
    if (navigationRef.current && navigationRef.current.canGoBack()) {
      navigationRef.current?.goBack();
    }
    rs("");
    return "";
  });
}
